import { FC } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import Breadcrumb from 'antd/es/breadcrumb/Breadcrumb'
import PageLayout from '../../../../../components/page-layout/page-layout'
import StampOrderForm from './components/stamp-order-form/stamp-order-form'
import useBreadcrumbItems from './hooks/use-breadcrumb-items'
import { useGetStampOrderByDocIdQuery } from '../../../../../store/api/stamp-orders-api'

interface StampOrderPageProps {}

const StampOrderPage: FC<StampOrderPageProps> = () => {
    const { docId = 'new' } = useParams()
    const [searchParams] = useSearchParams()
    const copyBy = searchParams.get('copyBy')
    const isNew = docId === 'new'
    const id = copyBy || (isNew ? '' : docId)

    const { data, isSuccess } = useGetStampOrderByDocIdQuery([id, { populate: '*' }], { skip: !id })

    const stampOrderId = data?.data.id
    const title = isNew ? 'Новый заказ штампа' : `Заказ штампа №${stampOrderId || ''}`
    const breadcrumbItems = useBreadcrumbItems(isNew ? '' : `${stampOrderId}`)

    return (
        <PageLayout title={title}>
            <Breadcrumb items={breadcrumbItems} />
            {id && isSuccess ? (
                <StampOrderForm stampOrder={data.data} copy={!!copyBy} key={'editing'} />
            ) : (
                <StampOrderForm key={'creating'} />
            )}
        </PageLayout>
    )
}

export default StampOrderPage
